const calcFiltersLength = (filters) =>
  Object.values(filters).filter((value) => value !== "" && value !== null && value.length !== 0).length;

export default calcFiltersLength;
